import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Convert potentially unsafe HTML to string to safe HTML string.
 */
@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  /** Constructor. */
  constructor(
    private sanitizer: DomSanitizer
  ) { }

  /**
   * Sanitize HTML string.
   *
   * @param input HTML string (potentially unsafe).
   * @returns Safe HTML string.
   */
  transform(html): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
